import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { I18nModule } from '@recruitee/i18n';

import { DropdownItemModule } from '../../../common/dropdown/dropdown-item/dropdown-item.module';
import { IconComponent } from './../../../common/icon/icon.module';
import { FormFieldModule } from './../../../forms/form-field/form-field.module';
import { InputModule } from './../../../forms/input/input.module';
import { TimeZonePickerDropdownListComponent } from './time-zone-picker-dropdown-list.component';

@NgModule({
  declarations: [TimeZonePickerDropdownListComponent],
  exports: [TimeZonePickerDropdownListComponent],
  imports: [
    FormFieldModule,
    IconComponent,
    InputModule,
    CommonModule,
    I18nModule,
    DropdownItemModule,
  ],
})
export class TimeZonePickerDropdownListModule {}
